<div class="relative">
  <div class="transition" [class.blur-sm]="isLoadingData()" [class.opacity-60]="isLoadingData()"
    [class.pointer-events-none]="isLoadingData()" [attr.aria-busy]="isLoadingData()">

    <div class="ea" [formGroup]="form">

      <!-- ═══ Steps ═══ -->
      <div class="ea-steps">

        <!-- ── 1. Cliente ── -->
        <section class="ea-step" [class.ea-step--done]="steps().client" aria-labelledby="ea-client-title">
          <div class="ea-step__head">
            <span class="ea-step__num" aria-hidden="true">
              @if (steps().client) {
                <svg class="size-3.5" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg>
              } @else { 1 }
            </span>
            <h3 id="ea-client-title" class="ea-step__title">Cliente</h3>
            @if (!selectedClient()) {
              <button type="button" class="ea-link ml-auto" (pointerdown)="onCreateClient($event)">
                <svg class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" /></svg>
                Nuevo cliente
              </button>
            }
          </div>

          @if (!selectedClient()) {
            <div class="ea-combo">
              <div class="ea-search">
                <svg class="ea-search__icon size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
                <input type="text" id="clientSearch" formControlName="clientSearch" autocomplete="new-password"
                  placeholder="Nombre, teléfono o correo"
                  role="combobox" aria-autocomplete="list" aria-controls="ea-client-results"
                  [attr.aria-expanded]="showClientResults()"
                  [attr.aria-activedescendant]="showClientResults() && clientResults()?.length ? 'ea-client-' + activeClientIndex() : null"
                  (keydown)="onClientSearchKeydown($event)"
                  class="ea-input ea-input--search" />
                @if (clientSearching()) {
                  <span class="ea-spinner" aria-hidden="true"></span>
                } @else if (clientQuery()) {
                  <button type="button" class="ea-search__clear" (click)="clearClientSearch()" aria-label="Borrar búsqueda">
                    <svg class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>
                  </button>
                }
              </div>

              @if (showClientResults() && clientResults() !== null) {
                <div class="ea-results" id="ea-client-results">
                  @if (clientResults()!.length === 0) {
                    <div class="ea-results__empty">
                      <p>Ningún cliente coincide con "{{ clientQuery() }}".</p>
                      <button type="button" class="ea-results__create" (click)="onCreateClientFromSearch($event)">
                        <svg class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" /></svg>
                        Crear cliente nuevo
                      </button>
                    </div>
                  } @else {
                    <ul role="listbox" aria-label="Clientes encontrados">
                      @for (c of clientResults()!; track c.userId; let i = $index) {
                        <li [id]="'ea-client-' + i" role="option" class="ea-result"
                          [class.ea-result--active]="i === activeClientIndex()"
                          [attr.aria-selected]="i === activeClientIndex()"
                          (mouseenter)="activeClientIndex.set(i)" (click)="selectClient(c)">
                          <span class="ea-avatar" aria-hidden="true">{{ initials(clientDisplayName(c)) }}</span>
                          <span class="min-w-0 flex-1">
                            <span class="ea-result__name">{{ clientDisplayName(c) }}</span>
                            <span class="ea-result__meta">
                              @if (c.phone) { <span class="tabular-nums">{{ c.phone }}</span> }
                              @if (c.email) { <span class="truncate">{{ c.email.toLowerCase() }}</span> }
                            </span>
                          </span>
                          @if (i === activeClientIndex()) {
                            <kbd class="ea-kbd" aria-hidden="true">Enter</kbd>
                          }
                        </li>
                      }
                    </ul>
                  }
                </div>
              } @else if (clientQuery().length > 0 && clientQuery().length < minClientQuery) {
                <p class="ea-hint">Escribe al menos {{ minClientQuery }} letras.</p>
              }
            </div>
          } @else {
            <div class="ea-picked">
              <span class="ea-avatar ea-avatar--lg" aria-hidden="true">{{ initials(clientDisplayName(selectedClient())) }}</span>
              <div class="min-w-0 flex-1">
                <p class="ea-picked__name">{{ clientDisplayName(selectedClient()) }}</p>
                <p class="ea-picked__meta">
                  @if (selectedClient()?.phone) { <span class="tabular-nums">{{ selectedClient()?.phone }}</span> }
                  @if (selectedClient()?.email) { <span class="truncate">{{ selectedClient()?.email }}</span> }
                </p>
              </div>
              <button type="button" class="ea-link" (click)="viewClientProfile()">Ver ficha</button>
              <button type="button" class="ea-link" (click)="clearClient()">Cambiar</button>
            </div>
          }
        </section>

        <!-- ── 2. Servicios ── -->
        <section class="ea-step" [class.ea-step--done]="steps().services" aria-labelledby="ea-services-title">
          <div class="ea-step__head">
            <span class="ea-step__num" aria-hidden="true">
              @if (steps().services) {
                <svg class="size-3.5" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg>
              } @else { 2 }
            </span>
            <h3 id="ea-services-title" class="ea-step__title">Servicios</h3>
            @if (selectedServices().length) {
              <span class="ea-step__aside">{{ totalDuration() }} min</span>
            }
          </div>

          @if (selectedServices().length > 0) {
            <ul class="ea-chips">
              @for (svc of selectedServices(); track svc.serviceId) {
                <li class="ea-chip">
                  <span class="font-medium">{{ svc.name }}</span>
                  <span class="ea-chip__meta">{{ svc.durationMinutes }} min@if (svc.price) {<span>, ${{ formatCurrency(svc.price) }}</span>}</span>
                  <button type="button" (click)="removeService(svc.serviceId)" [attr.aria-label]="'Quitar ' + svc.name">
                    <svg class="size-3.5" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>
                  </button>
                </li>
              }
            </ul>
          }

          <div class="ea-combo">
            <div class="ea-search">
              <svg class="ea-search__icon size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
              </svg>
              <input type="text" formControlName="serviceSearch" autocomplete="off"
                [placeholder]="selectedServices().length ? 'Agregar otro servicio' : 'Busca o elige un servicio'"
                (focus)="onServiceFocus()" (blur)="onServiceBlur()" (input)="onServiceInput($event)"
                class="ea-input ea-input--search" />
            </div>

            @if (isServiceOpen()) {
              <div class="ea-results">
                @if ((serviceResults$ | async); as servs) {
                  @if (servs.length === 0) {
                    <div class="ea-results__empty"><p>Ningún servicio coincide.</p></div>
                  } @else {
                    <ul>
                      @for (s of servs; track s.serviceId) {
                        @if (!isServiceAlreadySelected(s.serviceId)) {
                          <li class="ea-result" (pointerdown)="addService($event, s)">
                            <span class="ea-result__name flex-1">{{ s.name }}</span>
                            <span class="ea-result__meta shrink-0">
                              @if (s.durationMinutes) { <span>{{ s.durationMinutes }} min</span> }
                              @if (s.price) { <span>${{ formatCurrency(s.price) }}</span> }
                            </span>
                          </li>
                        }
                      }
                    </ul>
                  }
                }
              </div>
            }
          </div>

          @if (selectedServiceHasSessions()) {
            <p class="ea-note ea-note--info">
              Este servicio incluye {{ selectedService()?.sessionsCount }} sesiones. Se agendarán las siguientes
              cada {{ selectedService()?.sessionIntervalDays || 7 }} días.
            </p>
          }
        </section>

        <!-- ── 3. Profesional ── -->
        <section class="ea-step" [class.ea-step--done]="steps().professional" aria-labelledby="ea-pro-title">
          <div class="ea-step__head">
            <span class="ea-step__num" aria-hidden="true">
              @if (steps().professional) {
                <svg class="size-3.5" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg>
              } @else { 3 }
            </span>
            <h3 id="ea-pro-title" class="ea-step__title">Profesional</h3>
          </div>

          @if (!selectedServices().length) {
            <p class="ea-hint">Elige un servicio para ver quién puede atenderlo.</p>
          } @else if (professionals().length === 0 && !isLoadingData()) {
            <p class="ea-note ea-note--warn">
              @if (selectedServices().length > 1) {
                Nadie del equipo tiene asignados todos estos servicios. Quita alguno o asígnalos en Configuración.
              } @else {
                Este servicio no tiene profesionales asignados. Asígnalos desde Configuración, en Servicios.
              }
            </p>
          } @else {
            <div class="ea-pros" role="radiogroup" aria-labelledby="ea-pro-title">
              @for (p of professionals(); track trackById($index, p)) {
                <button type="button" role="radio" class="ea-pro"
                  [attr.aria-checked]="professionalId() === p.userId"
                  (click)="selectProfessional(p.userId)">
                  <span class="ea-pro__dot" [style.background-color]="p.color || 'var(--color-brand-500)'" aria-hidden="true"></span>
                  {{ getProfessionalDisplayName(p) }}
                </button>
              }
            </div>
          }
        </section>

        <!-- ── 4. Fecha y hora ── -->
        <section class="ea-step" [class.ea-step--done]="steps().time" aria-labelledby="ea-time-title">
          <div class="ea-step__head">
            <span class="ea-step__num" aria-hidden="true">
              @if (steps().time) {
                <svg class="size-3.5" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg>
              } @else { 4 }
            </span>
            <h3 id="ea-time-title" class="ea-step__title">Fecha y hora</h3>
            @if (selectedDateSignal()) {
              <span class="ea-step__aside capitalize">{{ formattedSelectedDate() }}</span>
              <button type="button" class="ea-link" (click)="clearSelectedDate()">Cambiar fecha</button>
            }
          </div>

          @if (!selectedDateSignal()) {
            <app-availability-calendar
              [businessSchedule]="businessScheduleRanges()"
              [dayAvailabilities]="calendarDayAvailabilities()"
              [selectedDate]="calendarSelectedDate()"
              [primaryColor]="'#465fff'"
              [isLoading]="isLoadingMonthAvailability()"
              (dateSelected)="onCalendarDateSelected($event)"
              (monthChanged)="onCalendarMonthChanged($event)">
            </app-availability-calendar>
          } @else {
            @if (isLoadingDayEvents()) {
              <div class="ea-slots animate-pulse" aria-hidden="true">
                @for (i of [1,2,3,4,5,6,7,8,9,10]; track i) {
                  <div class="h-9 rounded-lg bg-gray-100 dark:bg-gray-800"></div>
                }
              </div>
            } @else if (timeSlots().length > 0) {
              <div #timeSlotsGrid class="ea-slot-scroll custom-scrollbar">
                @for (group of groupedTimeSlots(); track group.label) {
                  <div class="ea-slot-group">
                    <p class="ea-slot-group__label">{{ group.label }}</p>
                    <div class="ea-slots">
                      @for (slot of group.slots; track slot.time) {
                        <button type="button" class="ea-slot"
                          [class.ea-slot--selected]="selectedTimeSlot() === slot.time"
                          [class.ea-slot--busy]="slot.blocked && selectedTimeSlot() !== slot.time"
                          [disabled]="!slot.available"
                          [attr.aria-pressed]="selectedTimeSlot() === slot.time"
                          [title]="slot.blocked ? 'Ocupado: ' + (slot.blockedLabel || 'otra cita') : ''"
                          (click)="selectTimeSlot(slot)">
                          {{ slot.label }}
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>

              <div class="ea-slot-foot">
                @if (selectedTimeSlot() && totalDuration() > 0) {
                  <p class="ea-slot-foot__range">
                    <svg class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" /></svg>
                    {{ startTimeLabel() }} a {{ endTimeLabel() }}
                  </p>
                }
                @if (dayEvents().length > 0) {
                  <p class="ea-hint">
                    <span class="ea-slot-key" aria-hidden="true">9:00</span>
                    {{ selectedProfessional() ? 'Ocupado para ' + getProfessionalDisplayName(selectedProfessional()!) : 'Ocupado por otra cita' }}
                  </p>
                }
              </div>
            } @else if (noSlotsForDay()) {
              <p class="ea-note ea-note--warn">Tu negocio no atiende este día. Elige otra fecha.</p>
            } @else if (!hasBusinessSchedule()) {
              <label class="ea-hint block">
                Hora de inicio
                <input type="time" (change)="onManualTimeChange($event)" [value]="selectedTimeSlot() || ''" class="ea-input mt-1" />
              </label>
            }
          }

          @if (isOutsideBusinessHours()) {
            <p class="ea-note ea-note--warn">Esta hora está fuera del horario de atención de tu negocio.</p>
          }
        </section>

        <!-- ── Más opciones ── -->
        <details class="ea-more" [open]="!!extrasSummary()">
          <summary>
            <span>Más opciones</span>
            <span class="ea-more__hint">
              {{ extrasSummary() || 'Comentario, promoción o repetir la cita' }}
            </span>
            <svg class="ea-more__chev size-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" /></svg>
          </summary>

          <div class="ea-more__body">
            <label class="block">
              <span class="ea-label">Comentario para la cita</span>
              <textarea rows="2" formControlName="notes" placeholder="Por ejemplo: prefiere tonos fríos" class="ea-input ea-textarea"></textarea>
            </label>

            @if (!promotionsLoading() && filteredPromotions().length > 0) {
              <label class="block">
                <span class="ea-label">Promoción</span>
                <select formControlName="promotionId" (change)="handlePromotionChange($event)" class="ea-input ea-select">
                  <option value="">Sin promoción</option>
                  @for (promo of filteredPromotions(); track promo.id) {
                    <option [value]="promo.id">{{ promo.name }} ({{ promotionLabel(promo) }})</option>
                  }
                </select>
              </label>
              @if (selectedPromotion()) {
                <p class="ea-hint -mt-2">{{ selectedPromotion()?.description }}</p>
              }
            }

            <div>
              <label class="ea-toggle">
                <input type="checkbox" formControlName="enableRecurrence" />
                <span>Repetir esta cita</span>
              </label>

              @if (form.get('enableRecurrence')?.value) {
                <div class="ea-recur">
                  <label class="block">
                    <span class="ea-label">Frecuencia</span>
                    <select formControlName="recurrenceFrequency" class="ea-input ea-select">
                      <option [value]="0">Cada día</option>
                      <option [value]="1">Cada semana</option>
                      <option [value]="2">Cada mes</option>
                    </select>
                  </label>

                  @if (form.get('recurrenceFrequency')?.value === 1) {
                    <div>
                      <span class="ea-label">Días</span>
                      <div class="ea-days">
                        @for (day of [{value:1,label:'L',name:'lunes'},{value:2,label:'M',name:'martes'},{value:3,label:'X',name:'miércoles'},{value:4,label:'J',name:'jueves'},{value:5,label:'V',name:'viernes'},{value:6,label:'S',name:'sábado'},{value:0,label:'D',name:'domingo'}]; track day.value) {
                          <button type="button" class="ea-day" [attr.aria-pressed]="isRecurrenceDaySelected(day.value)"
                            [attr.aria-label]="day.name" (click)="toggleRecurrenceDay(day.value)">
                            {{ day.label }}
                          </button>
                        }
                      </div>
                    </div>
                  }

                  <div>
                    <span class="ea-label">Termina</span>
                    <div class="space-y-2">
                      <label class="ea-radio">
                        <input type="radio" name="recurrenceEndType" value="date" (change)="onRecurrenceEndTypeChange('date')"
                          [checked]="!form.get('recurrenceOccurrenceCount')?.value" />
                        <span>El</span>
                        <span class="flex-1" [class.opacity-50]="!!form.get('recurrenceOccurrenceCount')?.value"
                          [class.pointer-events-none]="!!form.get('recurrenceOccurrenceCount')?.value">
                          <input #recurrenceEndDateInput type="text" class="ea-input h-9 cursor-pointer"
                            placeholder="Fecha de fin" readonly autocomplete="off" />
                        </span>
                      </label>
                      <label class="ea-radio">
                        <input type="radio" name="recurrenceEndType" value="count" (change)="onRecurrenceEndTypeChange('count')"
                          [checked]="!!form.get('recurrenceOccurrenceCount')?.value" />
                        <span>Después de</span>
                        <input type="number" formControlName="recurrenceOccurrenceCount" min="1" max="100"
                          [disabled]="!!form.get('recurrenceEndDate')?.value" placeholder="5"
                          class="ea-input h-9 w-20" />
                        <span>veces</span>
                      </label>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </details>
      </div>

      <!-- ═══ Summary: what will be booked, and what's missing ═══ -->
      <aside class="ea-summary" aria-label="Resumen de la cita">
        <p class="ea-summary__title">Resumen</p>

        <dl class="ea-summary__list">
          <div>
            <dt>Cliente</dt>
            <dd [class.ea-missing]="!selectedClient()">
              {{ selectedClient() ? clientDisplayName(selectedClient()) : 'Falta elegir' }}
            </dd>
          </div>
          <div>
            <dt>Servicios</dt>
            @if (selectedServices().length) {
              <dd>
                @for (svc of selectedServices(); track svc.serviceId) {
                  <span class="block truncate">{{ svc.name }}</span>
                }
              </dd>
            } @else {
              <dd class="ea-missing">Falta elegir</dd>
            }
          </div>
          <div>
            <dt>Profesional</dt>
            <dd [class.ea-missing]="!selectedProfessional()">
              @if (selectedProfessional(); as p) {
                <span class="inline-flex items-center gap-2">
                  <span class="ea-pro__dot" [style.background-color]="p.color || 'var(--color-brand-500)'" aria-hidden="true"></span>
                  {{ getProfessionalDisplayName(p) }}
                </span>
              } @else {
                Falta elegir
              }
            </dd>
          </div>
          <div>
            <dt>Cuándo</dt>
            @if (selectedDateSignal() && selectedTimeSlot()) {
              <dd>
                <span class="block capitalize">{{ formatDateDisplay(selectedDateSignal()!) }}</span>
                <span class="block font-semibold tabular-nums">
                  {{ startTimeLabel() }}@if (totalDuration() > 0) {<span> a {{ endTimeLabel() }}</span>}
                </span>
              </dd>
            } @else {
              <dd class="ea-missing">{{ selectedDateSignal() ? 'Falta la hora' : 'Falta elegir' }}</dd>
            }
          </div>
        </dl>

        @if (totalPrice() > 0) {
          <div class="ea-summary__total">
            @if (promotionDiscount() > 0) {
              <div class="ea-summary__row">
                <span>Subtotal</span><span>${{ formatCurrency(totalPrice()) }}</span>
              </div>
              <div class="ea-summary__row ea-summary__row--discount">
                <span>Descuento</span><span>−${{ formatCurrency(promotionDiscount()) }}</span>
              </div>
            }
            <div class="ea-summary__row ea-summary__row--total">
              <span>Total</span><span>${{ formatCurrency(finalPrice()) }}</span>
            </div>
            @if (totalDuration() > 0) {
              <p class="ea-hint">{{ totalDuration() }} min en total</p>
            }
          </div>
        }
      </aside>
    </div>
  </div>
</div>

<!-- Hidden input for autocomplete workaround -->
<input type="text" autocomplete="username" tabindex="-1" aria-hidden="true"
  style="position:absolute; left:-9999px; opacity:0;">

<!-- People Add Drawer -->
<app-people-add-drawer [open]="drawerOpen" [endpoint]="'clients'" [title]="'Nuevo cliente'"
  (close)="onDrawerClose()" (created)="onClientCreated($event)">
</app-people-add-drawer>
